module.exports = __webpack_public_path__ + "static/media/nz.d29645cf.svg";